import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

const Wrapper = styled.div`
  width: 100%;
`;
const Title = styled.div`
  font-family: NotoSansTC-Bold;
  font-size: 20px;
  color: ${colors.BlueGray_800};
  display: flex;
  align-items: center;
  height: 53px;
  /* 新增：聚焦時的外框樣式 (參考之前討論的技巧) */
  &:focus {
	outline: 2px solid;
	outline-offset: -2px;
  }
`;
const TitleText = styled.div`
  display: flex;
  text-align: left;
`;
const Icon = styled.div<{ color?: string }>`
  margin-left: 24px;
  color: ${(prop) => prop.color};
`;
const Content = styled.div<{ isShow: boolean }>`
  display: ${(props) => {
    return props.isShow ? 'grid' : 'none';
  }};
  width: 100%;
  gap: 8px;
`;

interface IProps {
  isShow?: boolean;
  setIsShow?: (isShow: boolean) => void;
  title: string;
  children?: React.ReactNode;
  color?: string;
}

const DropdownInfo: React.FC<IProps> = ({ isShow, setIsShow, title, children, color }) => {
	// 處理鍵盤觸發（Enter 或 Space）
	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault(); // 防止 Space 鍵捲動頁面
			setIsShow && setIsShow(!isShow);
	    }
	};
  return (
    <Wrapper>
      <Title tabIndex={0} role="button" aria-expanded={isShow} onKeyDown={handleKeyDown} onClick={() => setIsShow && setIsShow(!isShow)}>
        <TitleText>{title}</TitleText>

        {!!children && <Icon color={color}>{isShow ? <FaAngleUp /> : <FaAngleDown />}</Icon>}
      </Title>
      {!!children && isShow && <Content isShow={isShow}>{children}</Content>}
    </Wrapper>
  );
};

export default DropdownInfo;
